export default __webpack_public_path__ + "static/media/culture.57de88a4.png";